export default __webpack_public_path__ + "static/media/banner1.0c599c9c.jpg";